// src/branding.js

const BRANDS = {
  fsmta: {
    organizationName: "Florida State Music Teachers Association",
    shortName: "FSMTA",
    logo: "/fsmta-logo.png",
    favicon: "/fsmta-favicon.ico",
    pageTitle: "FSMTA Online Theory Exams",
    examSubtitle: "Online Theory & Aural Exams",
    footer: "© Florida State Music Teachers Association"
  },
  tmta: {
    organizationName: "Texas Music Teachers Association",
    shortName: "TMTA",
    logo: "/tmta-logo.png",
    favicon: "/tmta-favicon.ico",
    pageTitle: "TMTA Online Theory Exams",
    examSubtitle: "Online Theory & World of Music Exams",
    footer: "© Texas Music Teachers Association"
  },

  ismta: {
    organizationName: "Illinois State Music Teachers Association",
    shortName: "ISMTA",
    logo: "/ismta-logo.png",
    favicon: "/ismta-favicon.ico",
    pageTitle: "ISMTA Online Theory Exams",
    examSubtitle: "Online Achievement in Music Exams",
    footer: "© Illinois State Music Teachers Association"
  }
};

export function getBrand() {
  return BRANDS.fsmta;
}

export function applyBrandToDocument(brand) {
  document.title = brand.pageTitle;

  let favicon = document.querySelector(
    'link[rel="icon"]'
  );

  if (!favicon) {
    favicon = document.createElement("link");
    favicon.rel = "icon";
    document.head.appendChild(favicon);
  }

  favicon.href = brand.favicon;
}